import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { isExpired, isExpiringSoon } from './integrationUtils';
import { formatDate } from '../../utils/date';

interface Props {
  expiresAt: string | null;
  /** A revoked key no longer works anyway, so its expiry needs no attention. */
  revoked?: boolean;
}

export const IntegrationKeyExpiry: FC<Props> = ({ expiresAt, revoked }) => {
  const { t, i18n } = useTranslation();
  const text = expiresAt ? formatDate(i18n, expiresAt) : t('integration.apiAccess.keys.noExpiry');

  if (revoked) return <>{text}</>;

  if (isExpired(expiresAt)) {
    return (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: 'error.main', fontWeight: 500 }}>
        <ErrorOutlineIcon fontSize="small" titleAccess={t('integration.apiAccess.keys.expired')} />
        {text}
      </Box>
    );
  }

  if (isExpiringSoon(expiresAt)) {
    return (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', color: 'warning.dark', fontWeight: 500 }}>
        <WarningAmberRoundedIcon fontSize="small" titleAccess={t('integration.apiAccess.keys.expiresSoon')} />
        {text}
      </Box>
    );
  }

  return <>{text}</>;
};
